import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { SelectOptionI } from '../../../shared/modules/configurable-form/components/form-select/models/select-option-i';
import { SelectOptionLoaderI } from '../../../shared/modules/configurable-form/components/form-select/models/select-option-loader-i';
import { State } from '../../reducers';
import { map } from 'rxjs/operators';
import { getOneClickReceivingPersons } from '@ordersnproducts/modules/one-click-order/selectors/one-click-receiving-person.selector';

@Injectable()
export class OneClickReceivingPersonLoaderService implements SelectOptionLoaderI {
  constructor(private store: Store<State>) {}

  loadOptions(formGroup: UntypedFormGroup): Observable<SelectOptionI[]> {
    return this.store.pipe(
      select(getOneClickReceivingPersons),
      map((receivingPersons) => {
        return receivingPersons.map((receivingPerson) => {
          return {
            id: receivingPerson.contactId,
            name: receivingPerson.name,
          };
        });
      }),
    );
  }
}
